
import { Image } from "element-ui"
import _ from "lodash"
import { getPrice } from "@/api/dshop"
import Storage from "@/utils/storage"
import { formatImgUrl } from "@/utils/utils"
import List from "@/components/ware-view/list"

export default {
  name: "WareRcmd",
  components: {
    [Image.name]: Image,
    List
  },
  props: {
    module: Object
  },
  data() {
    return {
      list: [],
      isLoadErr: false
    }
  },
  computed: {
    banner() {
      return this.module?.data?.wareRcmds.banner
    },
    bannerCls() {
      return {
        "load-error": this.isLoadErr
      }
    },
    imgBgColor() {
      return this.module?.data?.wareRcmds.imgBgColor
    },
    isBannerLink() {
      return this.banner?.ctg?.redirectType === "1" && this.banner?.ctg?.link.app
    },
    wareList() {
      return this.list.map(item => ({
        sku: item.skuId,
        wareName: item.wareName,
        wareImg: item.wareImgUrl,
        warePrice: item.unitProPrice,
        packingSpecification: item.packingSpecification,
        wareStatus: item.wareStatus,
        allowCc: item.allowCc, // 自提标识
        promotionWareVO: {
          unitProPrice: item.unitProPrice || item.warePrice * 100,
          marketPrice: item.oldPrice,
          showLinePrice: item.showOriginalPrice,
          promotionInfoList: _.isEmpty(item.promotionTag)
            ? []
            : item.promotionTag.map(tag => ({
                displayInfo: {
                  proTag: tag
                }
              }))
        }
      }))
    }
  },
  created() {
    this.list = this.module?.data?.wareRcmds.normal || []
  },
  methods: {
    async getWareDetailData() {
      const { commonReqParams = {} } = Storage.get("commData") || {}
      const { custId } = Storage.get("accountInfo", { useBase64: true }) || {}
      const showOffPrice = this.module?.data?.wareRcmds?.showOffPrice

      const skuChunks = _.chunk(this.list, 99) // 将 skuId 切片为大小为 99 的子数组
      const promises = skuChunks.map(skuChunk => {
        const skuParams = skuChunk.map(item => {
          if (item.wareTag) {
            return item.wareTag
          }
          return JSON.stringify({ skuId: item.skuId })
        })

        return getPrice({
          param: JSON.stringify({
            skuParams: "[" + skuParams.toString() + "]",
            venderId: commonReqParams.venderId,
            storeId: commonReqParams.storeId,
            userId: custId || "",
            platForm: "APP",
            terminal: "PC",
            invokeSysName: "dshop3.0",
            lang: commonReqParams["superweb-locale"]
          })
        })
      })

      try {
        const responses = await Promise.allSettled(promises) // 并发调用 getPrice 接口

        responses.forEach((response, index) => {
          if (response.status === "fulfilled") {
            const priceData = response.value.data || {}
            const skuChunk = skuChunks[index]
            skuChunk.forEach(item => {
              const info = priceData[item.skuId]
              if (info) {
                const stock = info.wareStock
                let isOOS = false
                if (stock !== null && stock !== undefined) {
                  isOOS = stock <= 0
                }
                const promotionTag = (info.proTags || []).filter((v, k) => !!v)
                const oldPrice = info.unitProPrice < info.marketPrice ? info.marketPrice : "" // 市场价是否展示逻辑:市场价>促销价

                item.stock = stock
                item.oldPrice = oldPrice
                item.wareStatus = isOOS ? 1 : 0
                item.unitProPrice = info.unitProPrice
                item.showOriginalPrice = showOffPrice === 1 && oldPrice
                item.promotionTag = promotionTag
              }
            })
          } else {
            console.error("Failed to fetch prices:", response.reason)
          }
        })
      } catch (error) {
        console.error("Failed to fetch prices:", error)
      }
    },
    onLoadImageError() {
      this.isLoadErr = true
    },
    formatImgUrl
  }
}
